import React, { useEffect, useRef } from "react";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

const blockStyles = makeStyles(theme => ({
  container: {
    overflow: "hidden",
    position: "relative",
  },
  image: {
    position: "absolute",
    left: "-10000%",
    right: "-10000%", 
    top: "-10000%",
    bottom: "-10000%",
    margin: "auto auto",
  },
  contain: {
    maxWidth: "10%",
    maxHeight: "10%",
    transform: "scale(10)",
  },
  cover: {
    minWidth: "1000%",
    minHeight: "1000%",
    transform: "scale(0.1)",
  }
}));

export const ScaleModeCover   = "cover";
export const ScaleModeContain = "contain";

const Video = (props) => {
  const classes = blockStyles();

  const videoPlayer = useRef();

  const { className, children, 
    autoPlay = true,
    controls = false,
    loop = true,
    muted = true,
    playIsInline = true,
    speed = 1
   } = props;
  const { scaleMode = ScaleModeCover } = props;

  useEffect(() => {
    
  }, []) 

  return (
    <div className = { clsx({
      [classes.container]: true, 
      [className]: true}) } >
      <video className = { clsx({
        [classes.image]: true, 
        [classes.cover]: scaleMode === ScaleModeCover,
        [classes.contain]: scaleMode === ScaleModeContain}) } 
             autoPlay = { autoPlay } 
             controls = { controls }
             loop = { loop }
             muted = { muted }
             playsInline = { playIsInline }>
        { children }
      </video>
    </div>
  );
};

Video.propTypes = {
  scaleMode: PropTypes.oneOf([ScaleModeCover, ScaleModeContain]),
  autoPlay: PropTypes.bool,
  controls: PropTypes.bool,
  loop: PropTypes.bool,
  muted: PropTypes.bool,
  playIsInline: PropTypes.bool,
  speed: PropTypes.number
};

export default Video;